// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"242":"d51a426edbfd2f96","857":"90624a1d39887954"}[chunkId] + ".js";
};